import React, { useMemo } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { useTheme } from '@emotion/react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import { carouselItems } from './consts';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { 
  AuthBox, 
  InnerFlexBox, 
  LoginButton, 
  MainPageBox, 
  RegisterButton, 
  SwiperSlideBox 
} from './styled';
import { useNavigate } from 'react-router-dom';

function Landing() {
  const { loginWithRedirect, isAuthenticated } = useAuth0();
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const containerWidth = isMobile ? '100%' : '60%';

  useMemo(() => {
    if(isAuthenticated){
      navigate('/admin')
    }
  }, [isAuthenticated]); 

  return (
    <MainPageBox>
      <InnerFlexBox 
        containerWidth={containerWidth} 
        isMobile={isMobile}
      >
        <Swiper
          modules={[Pagination, Navigation]}
          pagination={{
            clickable: true,
            bulletActiveClass: 'swiper-pagination-bullet-active',
            bulletClass: 'swiper-pagination-bullet',
          }}
          navigation={!isMobile}
          spaceBetween={30}
          slidesPerView={1}
          style={{
            width: '100%',
            borderRadius: '1rem',
            height: '100%'
          }}
        >
          {carouselItems.map((item, index) => (
            <SwiperSlide key={index}>
              <SwiperSlideBox
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%',
                  padding: '2rem',
                  textAlign: 'center'
                }}
              >
                <img 
                  style={{
                    flex: '0 0 auto',
                    height: '10rem',
                    maxWidth: '20rem',
                    marginBottom: '1rem',
                    objectFit: 'contain'
                  }} 
                  src={item.image} 
                  alt={item.title} 
                />
                <Typography 
                  variant={isMobile ? 'h4' : 'h3'} 
                  sx={{ 
                    color: theme.palette.whites.main,
                    marginBottom: '1rem',
                    width: '100%'
                  }}
                >
                  {item.title}
                </Typography>
                <Typography 
                  variant="h6" 
                  sx={{ 
                    color: theme.palette.whites.main,
                    maxWidth: '800px',
                    margin: '0 auto',
                    padding: '0 1rem',
                    marginBottom: '3rem'
                  }}
                >
                  {item.description}
                </Typography>
              </SwiperSlideBox>
            </SwiperSlide>
          ))}
        </Swiper>
        <AuthBox>
          <LoginButton
            variant="contained"
            onClick={() => loginWithRedirect({ screen_hint: 'login' })}
            isMobile={isMobile}
          >
            Login
          </LoginButton>
          <RegisterButton
            variant="outlined"
            onClick={() => loginWithRedirect({ screen_hint: 'signup' })}
            isMobile={isMobile}
          >
            Register
          </RegisterButton>
        </AuthBox>
      </InnerFlexBox>
    </MainPageBox>
  );
}

export default Landing;